import React, {Component} from 'react';
import DayJs from 'dayjs';

import './index.less';

class GstDateSelect extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectIdx: '',
      value: '所有日期',
      prevArr: [], // 之前日期
      arr: [], // 可用日期
      nextArr: [], // 之后日期
      selectDates:this.props.data.schedule_date == 1?new Array(2).fill(0):(this.props.defaultValue?.map((d)=>DayJs(String(d)).unix())||new Array(2).fill(0))
    }
  }
  componentDidMount() {
    this.setData((dates) => {
      if(this.props.data.schedule_date == 1) {
         this.onSelect(0,dates[0].date);  
      }
      this.onOk(true);
    });
  }

  setData(cb) {
    let arr = [], prevArr = [], nextArr = [];
    let nD = DayJs(), nW = (nD.day()===0?7:nD.day()) - 1;

    // 之前
    for(let i = 1; i<=nW; i++) {
      prevArr.push(nD.subtract(i, 'day').format('M.DD'))
    }
    // 当前往后14天
    for(let i = 0; i<14; i++) {
      const date = nD.add(i, 'day');

      if(i === 0) {
        arr.push({date, zh: '今天'})
      } else if(i===1) {
        arr.push({date, zh: '明天'})
      } else {
        arr.push({date, zh: date.format('M.DD')})
      }
    }
    // 之后
    for(let i = 0; i<7-nW; i++) {
      nextArr.push(nD.add(14+i, 'day').format('M.DD'))
    }

    this.setState({
      arr,
      prevArr,
      nextArr
    }, () => {
      if(cb) cb(arr);
    })
  }

  toggleModal(data) {
    this.props.onToggle(data)
  }

  onSelect(idx, data) {
    let {selectDates} = this.state;

    if(!selectDates[0]) {
      selectDates[0] = data.unix();
    } else if(!selectDates[1]) {
      selectDates[1] = data.unix();
    } else {
      selectDates = new Array(2);
      selectDates[0] = data.unix();
    }
    this.setState({
      selectDates,
      selectIdx: idx
    })
  }

  onSelectClick(key) {
    this.props.onToggle(key)
  }

  onOk(isDef) {
    let dates = [], value = '';
    const {selectDates} = this.state;
    console.log('selectDates')
    console.log(selectDates)
    selectDates.forEach((time, idx) => {
      if(time) {
        dates.push(Number(DayJs(time*1000).format('YYYYMMDD')));
        value += DayJs(time*1000).format('MM.DD')+'-'
      }
    })
    this.setState({
      value: value.slice(0, value.length-1) || '所有日期'
    });

    if(!isDef) this.toggleModal(-1);
    if(this.props.onSelect) this.props.onSelect({dates});
  }

  onReset() {
    this.setState({
      selectIdx: '',
      selectDates: new Array(2).fill(0)
    })
  }

  render() {
    const {isShow} = this.props;
    const {value, selectIdx, prevArr, arr, nextArr, selectDates} = this.state;
    const {key} = this.props.data || {};
    const datesArr = selectDates.sort();
    return (
      <div className="gst-date-select">
        <div className="gst-date-select-view" onClick={() => this.onSelectClick(key)}>
          <span className="val">{value}</span>
          <span className="icon icon-arrow" />
        </div>
        {isShow && (
          <div className="gst-date-select-mask" onClick={() => this.toggleModal()} />
        )}
        {isShow && (
          <div className="gst-date-select-content">
            <div className="weeks">
              <span>周一</span>
              <span>周二</span>
              <span>周三</span>
              <span>周四</span>
              <span>周五</span>
              <span>周六</span>
              <span>周日</span>
            </div>
            <div className="dates">
              {prevArr.map((item, idx) => (
                <span key={idx} className="disable">{item}</span>
              ))}
              {arr.map((item, idx) => (
                <span key={idx} 
                className={(idx)===selectIdx||
                (datesArr[0]>0&&item.date.unix()>=datesArr[0]&&item.date.startOf('day').unix()<=datesArr[1])||
                (datesArr.length===1&&datesArr[0]===item.date.startOf('day').unix())?'active':''} onClick={() => this.onSelect(idx, item.date)}>
                  {item.zh}
                  </span>
              ))}
              {nextArr.map((item, idx) => (
                <span key={idx} className="disable">{item}</span>
              ))}
            </div>
            <div className="btns"><div className="btn reset" onClick={() => this.onReset()}>重置</div><div className="btn ok" onClick={() => this.onOk()}>确认</div></div>
          </div>
        )}
      </div>
    );
  }
}

export default GstDateSelect;
